import React from 'react';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

// Components

// Images
import wmmsBlack from '../../../assets/images/wmms-blk.svg';

// Styles
const Root = styled('div')(({ theme }) => ({
  '& .footer': {
    backgroundColor: theme.palette.common.white,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },

  '& .footer .footer__logo': {
    height: theme.spacing(3),
  },
}));

export default function FooterError() {
  return (
    <Root>
      <footer className="footer">
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item>
            <img
              className="footer__logo"
              src={wmmsBlack}
              alt="Symbol of the Government of Canada / Symbole du gouvernement du Canada"
              loading="lazy"
            />
          </Grid>
        </Grid>
      </footer>
    </Root>
  );
}
